<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import edit from './codeEdit';
import config from '@/modules/config/columns';
export default {
	created() {
	},
	props: {
		handlerSearch: {
			type: Function,
			required: true
		},
		searchQuery: {
			type: Object,
			required: true
		},
		selectOptions: {
			type: Object,
			required: true
		}
	},
	data() {
        return {
			options: [{
				value: '选项1',
				label: '黄金糕'
				}, {
				value: '选项2',
				label: '双皮奶'
			}]
        }
    },
	methods: {
		addModel() {
			this.$emit('handleAdd');
		},
		download() {
		},
		reset() {
			this.$clearObject(this.searchQuery);
		},
		...mapActions('zft', ['carouseAdd']),
	},
	computed: {
		...mapGetters('nameRules', ['codeOption']),
		config() {
			return config;
		}
	},
	components: {
		edit
	}
}
</script>
<template>
<div class="name-search">
	<el-row :gutter="20">
	    <el-col :span="6">
	  	    <el-input v-model ="searchQuery.name" clearable
			    placeholder="轮播名称"
			></el-input>
	    </el-col>
		<!-- <el-col :span="4">
			<el-select v-model="searchQuery.code" class="common-width" placeholder="轮播位置">
				<el-option
					v-for="item in options"
					:key="item.value"
					:label="item.label"
					:value="item.value"
				>
				</el-option>
			</el-select>
	    </el-col> -->
		<el-col :span="6">
			<el-select v-model="searchQuery.status" class="common-width" placeholder="展示状态">
				<el-option
					v-for="item in selectOptions.status"
					:key="item.key"
					:label="item.typeName"
					:value="item.key"
				>
				</el-option>
			</el-select>
	    </el-col>
		<el-col :span="6">
			<el-date-picker class="common-width"
				v-model="searchQuery.queryTimeBegin"
				type="date"
				placeholder="选择开始日期"
				value-format="yyyy-MM-dd"
			>
			</el-date-picker>
	    </el-col>
		<el-col :span="6">
			<el-date-picker class="common-width"
				v-model="searchQuery.queryTimeEnd"
				type="date"
				placeholder="选择结束日期"
				value-format="yyyy-MM-dd"
			>
			</el-date-picker>
	    </el-col>
	</el-row><br/>
	<el-row :gutter="20">
		<el-col :span="12">
	        <el-button type="primary" @click="handlerSearch">搜索</el-button>
	        <!-- <el-button type="primary" @click="download">导出数据</el-button> -->
	        <el-button type="primary" @click="reset">恢复默认</el-button>
	        <el-button type="primary" @click="addModel">新增</el-button>

	    </el-col>
	</el-row>
</div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%

/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner
    width auto
</style>
